/* ============================================
   TRADUÇÕES PORTUGUESAS
   ============================================ */

export const pt = {
  // Estados da partida
  matchStates: {
    notStarted: 'Não iniciado',
    firstHalf: '1º tempo',
    halfTime: 'Intervalo',
    secondHalf: '2º tempo',
    extraTimeFirstHalf: 'Prorrogação 1º tempo',
    extraTimeHalfTime: 'Pausa da prorrogação',
    extraTimeSecondHalf: 'Prorrogação 2º tempo',
    penalties: 'Pênaltis',
    finished: 'Finalizado',
    postponed: 'Adiado',
    cancelled: 'Cancelado',
    interrupted: 'Interrompido',
  },

  // Eventos
  events: {
    goal: 'Gol',
    yellowCard: 'Cartão amarelo',
    redCard: 'Cartão vermelho',
    substitution: 'Substituição',
    corner: 'Escanteio',
    freeKick: 'Falta',
    penalty: 'Pênalti',
    offside: 'Impedimento',
    injury: 'Lesão',
    var: 'VAR',
    shotOnTarget: 'Chute no gol',
    shotOffTarget: 'Chute para fora',
    throwin: 'Lateral',
    dangerousAttack: 'Ataque perigoso',
    attack: 'Ataque',
    possession: 'Posse de bola',
    sixMeters: 'Área pequena',
    goalKick: 'Tiro de meta',
    blockedShot: 'Chute bloqueado',
    penaltyUnconfirmed: 'Pênalti (não confirmado)',
    penaltyMissed: 'Pênalti desperdiçado',
    goalNotification: 'Notificação de gol',
    kickoff: 'Pontapé inicial',
    secondHalfKickoff: 'Pontapé inicial 2º tempo',
    ballLost: 'Bola perdida',
    ballRecovered: 'Bola recuperada',
    ownGoal: 'Gol contra',
    matchStart: 'Início',
    matchEnd: 'Fim',
    halfTimeScore: 'Resultado do intervalo',
    cardConfirmed: 'Cartão confirmado',
    extraTimeEnded: 'Prorrogação encerrada',
    penaltyEnded: 'Pênalti encerrado',
    penaltyShootout: 'Disputa de pênaltis',
    penaltyShootoutMissed: 'Pênalti desperdiçado (disputa)',
  },

  // Indicadores de posse
  possession: {
    home: 'Posse mandante',
    away: 'Posse visitante',
    attack: 'Ataque',
    dangerousAttack: 'Ataque perigoso',
  },

  // Interface
  ui: {
    home: 'Mandante',
    away: 'Visitante',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    loading: 'Carregando...',
    noMatch: 'Nenhuma partida selecionada',
    selectMatch: 'Selecionar partida',
  },

  // Tempo adicional
  addedTime: {
    label: 'Acréscimos',
    minute: 'min',
    minutes: 'min',
  },

  // Notificações
  notifications: {
    matchStarted: 'Início da partida',
    matchEnded: 'A partida terminou',
    halfTimeStarted: 'Intervalo',
    secondHalfStarted: 'Retomada da partida',
    matchAboutToStart: 'A partida vai começar',
    matchAboutToResume: 'A partida vai recomeçar',
    penaltiesInProgress: 'A disputa está em andamento',
    // Notificações de eventos centralizadas
    kickoffTitle: 'Pontapé inicial',
    kickoffSubtitle: 'A partida começou!',
    goalTitle: 'Gol! gol! gol!',
    yellowCardTitle: 'Cartão amarelo',
    yellowCardSubtitle: 'Um jogador recebeu cartão amarelo',
    redCardTitle: 'Cartão vermelho',
    redCardSubtitle: 'Um jogador recebeu cartão vermelho',
    injuryTitle: 'Lesão',
    injurySubtitle: 'Um jogador está lesionado',
    substitutionTitle: 'Substituição',
    substitutionSubtitle: 'Mudança em andamento',
    varTitle: 'VAR em andamento',
    varSubtitle: 'O árbitro tomará uma decisão',
    varCancelledTitle: 'Gol anulado',
    varCancelledSubtitle: 'O gol foi anulado pelo VAR',
    addedTimeTitle: 'Acréscimos',
    addedTimeSubtitle: 'Serão jogados minutos adicionais!',
  },

  // Indicadores de campo (MAIÚSCULAS)
  fieldIndicators: {
    possession: 'POSSE DE BOLA',
    attack: 'ATAQUE',
    dangerousAttack: 'ATAQUE PERIGOSO',
    throwin: 'LATERAL',
    freeKick: 'FALTA',
    dangerousFreeKick: 'FALTA PERIGOSA',
    corner: 'ESCANTEIO',
    goalKick: 'TIRO DE META',
    penalty: 'PÊNALTI',
    shotOnTarget: 'CHUTE NO GOL',
    shotOffTarget: 'CHUTE PARA FORA',
    offside: 'IMPEDIMENTO',
    ballLost: 'BOLA PERDIDA',
  },

  // Contagem regressiva
  countdown: {
    hours: 'H',
    minutes: 'MIN',
    seconds: 'SEG',
  },

  // Controles
  controls: {
    openRadar: 'Abrir Radar',
    reload: 'Recarregar',
    date: 'Data',
    match: 'Partida',
    delay: 'Atraso (segundos)',
    fieldLength: 'Comprimento (px)',
    fieldWidth: 'Largura (px)',
    fieldColor: 'Cor do campo',
    language: 'Idioma',
    connectedStatus: 'Conectado',
    disconnectedStatus: 'Desconectado',
  },
};
